/**
 * This is a simple rate limiter that allows a certain number of actions per minute.
 */
export class Throttler {
  private lastReset: number = 0;
  private count: number = 0;
  private readonly limit: number;
  private readonly interval: number;

  constructor({
    limitPerMsPeriod,
    msPeriod,
  }: {
    limitPerMsPeriod: number;
    msPeriod: number;
  }) {
    this.limit = limitPerMsPeriod;
    this.interval = msPeriod;
  }

  canProceed(count = 1): boolean {
    const now = Date.now();

    // Reset count if the interval has passed
    if (now - this.lastReset >= this.interval) {
      this.lastReset = now;
      this.count = 0;
    }

    // Check if we're under the limit
    if (this.count < this.limit) {
      this.count += count;
      return true;
    }

    return false;
  }
}
